import * as types from '../types/customerTypes';

const initialState = {
  customers: [],
  customer: null,
  customerOrders: [],
  stats: null,
  loading: false,
  error: null,
};

function customerReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CUSTOMERS_REQUEST:
    case types.FETCH_CUSTOMER_STATS_REQUEST:
    case types.FETCH_CUSTOMER_BY_ID_REQUEST:
    case types.FETCH_CUSTOMER_ORDERS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_CUSTOMERS_SUCCESS:
      return { ...state, loading: false, customers: action.payload };
    case types.FETCH_CUSTOMER_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case types.FETCH_CUSTOMER_BY_ID_SUCCESS:
      return { ...state, loading: false, customer: action.payload };
    case types.FETCH_CUSTOMER_ORDERS_SUCCESS:
      return { ...state, loading: false, customerOrders: action.payload };
    case types.FETCH_CUSTOMERS_FAILURE:
    case types.FETCH_CUSTOMER_STATS_FAILURE:
    case types.FETCH_CUSTOMER_BY_ID_FAILURE:
    case types.FETCH_CUSTOMER_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default customerReducer;
